import { writable } from "svelte/store";

function createFilter() {
  const { subscribe, set, update } = writable({});

  return {
    subscribe,
    set,
    add: (tag) =>
      update((n) => {
        n[tag] = false;
        return n;
      }),
    toggle: (tag) =>
      update((n) => {
        n[tag] = !n[tag];
        return n;
      }),
    reset: () =>
      set((n) => {
        let keys = Object.keys(n);
        for (let index = 0; index < keys.length; index++) {
          keys[index] = false;
        }
      }),
  };
}

export const category_tags = createFilter();

function createPageCount() {
  const { subscribe, set, update } = writable(1);

  return {
    subscribe,
    set,
    increment: () => update((n) => n + 1),
    decrement: () => update((n) => n - 1),
    reset: () => set(1),
  };
}

export const page_count = createPageCount();
